<mg-icon
  class="sorting-arrows"
  iconName="mg-filter-arrows"
  [ngClass]="classes"
  (click)="toggleSort()">
</mg-icon>
